// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var InfoWindowDisplayMode;
(function (InfoWindowDisplayMode) {
    InfoWindowDisplayMode[InfoWindowDisplayMode["SeparateWindow"] = 0] = "SeparateWindow";
    InfoWindowDisplayMode[InfoWindowDisplayMode["AttachedToCursor"] = 1] = "AttachedToCursor";
    InfoWindowDisplayMode[InfoWindowDisplayMode["Hidden"] = 2] = "Hidden";
})(InfoWindowDisplayMode || (InfoWindowDisplayMode = {}));
export function getInfoWindowDisplayModeKey(value) {
    switch (value) {
        case InfoWindowDisplayMode.SeparateWindow:
            return 'chart.menu.InfoWindowSeparateWindow';
        case InfoWindowDisplayMode.AttachedToCursor:
            return 'chart.menu.InfoWindowAttachedToCursor';
        case InfoWindowDisplayMode.Hidden:
            return 'chart.menu.InfoWindowHidden';
        default:
            return '';
    }
}
